import React, { useState, useEffect, useContext } from "react";
 
import { Link } from "react-router-dom";
import userIcon from "../../../../asset/images/icon_users.svg";
import Dashboard from "../../../../asset/images/icon_dashboard.svg";
import TMS from "../../../../asset/images/icon_tms.svg";
import Reports from "../../../../asset/images/icon_reports.svg";
import Masters from "../../../../asset/images/icon_masters.svg";
import Settings from "../../../../asset/images/icon_setting.svg";
import userIcon_wh from "../../../../asset/images/userIcon_wh.svg";
import Dashboard_wh from "../../../../asset/images/Dashboard_wh.svg";
import TMS_wh from "../../../../asset/images/Tms_wh.svg";
import Reports_wh from "../../../../asset/images/Reports_wh.svg";
import Masters_wh from "../../../../asset/images/Masters_wh.svg";
import Settings_wh from "../../../../asset/images/Settings_wh.svg";
import arrow_b from "../../../../asset/images/icon_down_arrow.svg" 
import Inward_wh from "../../../../asset/images/Inward_wh.svg";
import Inward from "../../../../asset/images/icon_inward.svg";
import { AuthContext } from "../../../../context";
import Logo from '../../../../asset/images/newlogo.svg';
import icon_logo_collapsed from '../../../../asset/images/icon_logo_collapsed.svg'; 
import SidebarButton from '../../../../asset/images/sidebarbutton.svg';
import WalletBalance from './WalletBalance';
import AppNotification from "./AppNotification";
import UserProfile from "./Profile";

const iconsObj = {
  "Dashboard": Dashboard,
  "User Management": userIcon,
  "AAJ Swift TMS": TMS,
  "Reports": Reports,
  "Masters": Masters,
  "Settings": Settings,
  "Inward": Inward,
}

 

export const Sidebar = (props) => {
  const [collapseLeftMenu, setcollapseLeftMenu] = useState(true);
  const [selectedModule, setselectedModule] = useState("");
  const [selectedsubModule, setselectedSubModule] = useState("");
  const [menuData, setMenuData] = useState([]);
  const [hoveredModule, setHoveredModule] = useState("");
  const [bgColor, setBgColor] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);
  const [selectedArrow, setSelectedArrow] = useState(false);
  const [selectedPrevTab, setSelectedPrevTab] = useState(null);
  const [arrowrotate, setArrowRotate] = useState(360);
  const authContext = useContext(AuthContext);

  useEffect(() => {
    console.log(props.appModules, "****props.appModules****")
    setMenuData(props.appModules);
  });
  function truncateCombinedName() {
    const firstName = localStorage.getItem("FirstName")
    const lastName = localStorage.getItem("LastName");
    const combinedName = `${firstName} ${lastName}`;
    return combinedName.length > 10 ? combinedName.substring(0, 10) + "..." : combinedName;
  }

  const handleLeftMenu = () => {
    // props.collapseLeftMenu();
    setHoveredModule(null);
    setcollapseLeftMenu(!collapseLeftMenu);
    props.collapseLeftMenu();
    //setBgColor(true);
  };

  const handleArrows = (module) => {

    if (selectedPrevTab == null) {
      setSelectedPrevTab(module);
      setSelectedArrow(!selectedArrow);
      setArrowRotate(270);
    }
    else {
      if (selectedPrevTab === module) {
        setSelectedArrow(!selectedArrow);
        setArrowRotate(180);
      }
      else {
        setArrowRotate(270);
        setSelectedArrow(selectedArrow);
        setSelectedPrevTab(module);
      }
    }
  };

  useEffect(() => {
    console.log(props.appModules, "****props.appModules****")
    setMenuData(props.appModules);
  });
  const SelectModule = (moduleCode) => {
    if (selectedModule === moduleCode) setselectedModule("");
    else setselectedModule(moduleCode);
  };


  const getIcon = (name) => {

    return iconsObj[name];
  }


  const handleMouseEnter = (moduleHover) => {
    setHoveredModule(moduleHover);
  };
  const handleMouseLeave = () => {
    //alert("abcn")
    setHoveredModule(null);
  };

  return (
    <>
   {!collapseLeftMenu && <div className={"sidebar-aaj"}>
      {/* Logo Section */}
      <div className="logo-section-aaj">
        <img src={Logo} alt="Logo" className="logo-aaj" />
        <img src={SidebarButton} alt="Logo" onClick={()=>{handleLeftMenu() }} className="sidder-button-aaj" />

      </div>

      <WalletBalance />

      
      <nav className="nav-section-aaj">



        <div >
          <div
            className="aside-dashboard-content_1"
          >
            <div className="aside-dashboard-icon_1 content-allignment-left-side_1">
              <Link to={"/"} className="dashboard">
                <div className="aside-dashboard-icon_1 content-allignment-left-side_2"
                  onClick={() => {
                    // setSelectedTab(item.module);
                    // SelectModule(item.module);
                    // handleArrows(item.module);
                  }}

                  key={"Dashboard"}>
                  <div style={{ display: "flex" }}>

                    <span>
                      <img
                        src={getIcon("Dashboard")} alt="dashboard-icon"
                        //  onClick={() => handleLeftMenu()}
                        style={{ height: "25px", width: "25px", loading: "lazy" }}

                      />
                    </span>
                    <span className="menu_label" >
                      {"Dashboard"}
                    </span>

                  </div>

                </div>
              </Link>
            </div>
          </div>
          {menuData
            .filter((x) => x.isAccount === false && x.module != "Mod_1")
            .map((item) => {
              return (
                <>
                  {!collapseLeftMenu ?
                    <div
                      className="aside-dashboard-content_1"
                    >
                      <div className="aside-dashboard-icon_1 content-allignment-left-side_1">
                        <div className="aside-dashboard-icon_1 content-allignment-left-side_2"
                          onClick={() => {
                            setSelectedTab(item.module);
                            SelectModule(item.module);
                            handleArrows(item.module);
                          }}
                          // style={selectedTab === item.module ? { backgroundColor: "#C2202B", borderRadius: "2px" } : {}}
                          key={item.module}>
                          <div style={{ display: "flex" }}>
                            <span>
                              <img src={selectedTab === item.module ? getIcon(item.name) : getIcon(item.name)} alt="dashboard-icon"
                                //  onClick={() => handleLeftMenu()}
                                style={{ height: "25px", width: "25px", loading: "lazy" }}

                              />
                            </span>
                            <span className="menu_label"

                            >
                              {item.name}
                            </span>
                          </div>
                          <div style={{ display: "flex", marginRight: "10px" }}>

                            <img

                              src={arrow_b}
                              alt="left side arrow icon"

                            />
                          </div>
                          <span
                            className="arrow-icon"

                          >
                            <i
                              className="fa fa-angle-down  fa-icon"

                            ></i>
                          </span>
                        </div>
                        <div
                          className="role-user"
                          style={
                            selectedModule == item.module
                              ? { display: "block" }
                              : { display: "none" }
                          }
                        >
                          <ul>
                            {item.children.map((item) => {
                              return (
                                <li
                                  onClick={() => {
                                    setselectedSubModule(item.module);
                                  }}
                                  className={
                                    selectedsubModule === item.module ? "active" : ""
                                  }
                                >
                                  <Link className="menu_label_link" to={item.url}  >
                                    {item.labelCode}</Link>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                    </div>
                    :
                    <div style={{ paddingRight: "11px" }}>
                      <span onMouseEnter={() => {
                        handleMouseEnter(item.module)
                      }}
                        onMouseLeave={() => {
                          handleMouseLeave();
                        }} className={collapseLeftMenu ? 'dashboard' : "dashboard random"}>
                        <span className="dashboard">
                          <img src={getIcon(item.name)} alt="dashboard-icon"
                            // onClick={() => handleLeftMenu()}
                            style={{ height: "42px", width: "42px" }}
                          />
                        </span>
                      </span>
                      <div
                        className="hover-text"
                        style={
                          hoveredModule == item.module
                            ? { display: "inline-block" }
                            : { display: "none" }
                        }
                      >
                        <ul>
                          <li>{item.name}  </li>
                          {item.children.map((item) => {
                            return (
                              <li
                                onClick={() => {
                                  setselectedSubModule(item.module);
                                }}
                                className={
                                  selectedsubModule === item.module ? "active" : ""
                                }
                              >

                                <Link to={item.url}>{item.labelCode}</Link>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>

                  }
                </>
              );
            })}
        </div>
      </nav>


      <AppNotification />
      <UserProfile />
    </div>
          }
    {collapseLeftMenu && <div className={"sidebar-aaj-collapsed"}>
      {/* Logo Section */}
      <div className="logo-section-aaj">
        <img src={icon_logo_collapsed} alt="Logo" className="logo-aaj" onClick={()=>{handleLeftMenu()}}  />
        

      </div>

       <WalletBalance isCollapsed={collapseLeftMenu} handleLeftMenu={()=>handleLeftMenu()} /> 
      <nav className="nav-section-aaj">  
        <div >
          <div
            className="aside-dashboard-content_1"
          >
            <div className="aside-dashboard-icon_1 content-allignment-left-side_1">
              <Link to={"/"} className="dashboard">
                <div className="aside-dashboard-icon_1 content-allignment-left-side_2"
                  onClick={() => {
                    // setSelectedTab(item.module);
                    // SelectModule(item.module);
                    // handleArrows(item.module);
                  }}

                  key={"Dashboard"}>
                  <div style={{ display: "flex" }}>

                    <span>
                      <img
                        src={getIcon("Dashboard")} alt="dashboard-icon"
                         onClick={() => handleLeftMenu()}
                        style={{ height: "25px", width: "25px", loading: "lazy" }}

                      />
                    </span>
                    

                  </div>

                </div>
              </Link>
            </div>
          </div>
          {menuData
            .filter((x) => x.isAccount === false && x.module != "Mod_1")
            .map((item) => {
              return (
                <>
                  { 
                   <div
                   className="aside-dashboard-content_1"
                 >
                   <div className="aside-dashboard-icon_1 content-allignment-left-side_1">
                     <Link to={"/"} className="dashboard">
                       <div className="aside-dashboard-icon_1 content-allignment-left-side_2"
                         onClick={() => {
                           // setSelectedTab(item.module);
                           // SelectModule(item.module);
                           // handleArrows(item.module);
                         }}
       
                         key={"Dashboard"}>
                         <div style={{ display: "flex" }}>
       
                           <span>
                           <div style={{ position: "relative", display: "inline-block", overflow: "hidden" }}>
  <img
    src={getIcon(item.name)}
    alt="dashboard-icon"
    onClick={() => handleLeftMenu()}
    style={{
      height: "25px",
      width: "25px",
      transition: "transform 0.3s ease-in-out",
    }}
    onMouseEnter={(e) => {
      e.target.style.transform = "scale(1.2)";
      e.target.nextSibling.style.visibility = "visible"; // Show tooltip
      e.target.nextSibling.style.opacity = "1";
    }}
    onMouseLeave={(e) => {
      e.target.style.transform = "scale(1)";
      e.target.nextSibling.style.visibility = "hidden"; // Hide tooltip
      e.target.nextSibling.style.opacity = "0";
    }}
  />
  <div
    style={{
      position: "absolute",
      top: "50%",
      left: "110%", 
      transform: "translateY(-50%)",
      backgroundColor: "#333",
      color: "#fff",
      padding: "5px 10px",
      borderRadius: "4px",
      fontSize: "12px",
      whiteSpace: "nowrap", 
      visibility: "hidden", 
      opacity: "0",
      transition: "opacity 0.3s ease-in-out",
      zIndex: "1000", 
    }}
  >
    {item.name}
  </div>
</div>



                           </span>
                           
       
                         </div>
       
                       </div>
                     </Link>
                   </div>
                 </div>

                  }
                </>
              );
            })}
        </div>
      </nav>


      <AppNotification isCollapsed={collapseLeftMenu} handleLeftMenu={()=>handleLeftMenu()} />
      <UserProfile isCollapsed={collapseLeftMenu} handleLeftMenu={()=>handleLeftMenu()} />
    </div>
          }
    </>
    
  );
};

export default Sidebar;
